<template>
	<div>
		<Layout :back="'/'" class="bg-primary " :navTransparent="true">
			<template slot="header">
				<h1>Mi perfil</h1>
				<p>¡Mantené tus datos actualizados!</p>
			</template>

			<div class="main-container p-4">
				<div>
					<FormulateForm ref="form" name="profile" v-model="form" @submit="save">
						<FormulateInput label="Foto de perfil" name="avatar" type="file" accept="images" listStyle="thumb" />

						<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

						<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />

						<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />

						<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="optional|^phone" />

						<FormulateInput type="identification" label="Documento de identidad" name="document" validation-name="Documento de identidad" validation="required|documentID" />

						<FormulateInput label="Empresa" validation-name="Empresa" name="business" placeholder="Empresa" validation="required" />
						<FormulateInput label="Departamento" validation-name="Departamento" name="department" :options="departments" type="select" placeholder="Seleccionar departamento" validation="required" />
					</FormulateForm>
				</div>
			</div>
			<template slot="footer">
				<div class="w-100 p-2">
					<div class="btn btn-primary btn-lg btn-block" v-ripple @click="$formulate.submit('profile')">
						<span v-if="saving">Guardando<i class="icon-loading"></i></span>
						<span v-else>Guardar</span>
					</div>
				</div>
			</template>
		</Layout>
	</div>
</template>
<script>
import gql from 'graphql-tag'
import Layout from '@/components/layout/Layout'
import { mapMutations } from 'vuex'

export default {
	name: 'UserForm',
	components: {
		Layout,
	},
	data() {
		return {
			form: {
				name: null,
				lastname: null,
				phone: null,
				email: null,
				avatar: null,
				document: {
					type: 'UY',
					number: null,
				},
				business: null,
				department: null,
			},
			loading: true,
			saving: false,
			departments: [
				{ value: 'montevideo', label: 'Montevideo' },
				{ value: 'artigas', label: 'Artigas' },
				{ value: 'canelones', label: 'Canelones' },
				{ value: 'cerro-largo', label: 'Cerro Largo' },
				{ value: 'colonia', label: 'Colonia' },
				{ value: 'durazno', label: 'Durazno' },
				{ value: 'flores', label: 'Flores' },
				{ value: 'florida', label: 'Florida' },
				{ value: 'lavalleja', label: 'Lavalleja' },
				{ value: 'maldonado', label: 'Maldonado' },
				{ value: 'paysandu', label: 'Paysandú' },
				{ value: 'rio-negro', label: 'Río Negro' },
				{ value: 'rivera', label: 'Rivera' },
				{ value: 'rocha', label: 'Rocha' },
				{ value: 'salto', label: 'Salto' },
				{ value: 'san-jose', label: 'San José' },
				{ value: 'soriano', label: 'Soriano' },
				{ value: 'tacuarembo', label: 'Tacuarembó' },
				{ value: 'treinta-y-tres', label: 'Treinta y tres' },
			],
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		...mapMutations(['updateLoggedUser']),
		load() {
			this.$apollo
				.query({
					query: gql`
						query {
							sellerLogged {
								id
								name
								lastname
								email
								phone {
									validated
									national
									international
								}
								document {
									number
									type
								}
								avatar {
									id
									url
									urlThumb
									type
								}
								business
								department
							}
						}
					`,

					fetchPolicy: 'no-cache',
				})
				.then(({ data }) => {
					this.form = this.$omitDeep(data.sellerLogged, ['__typename'])
					this.loading = false
				})
		},
		save() {
			if (!this.saving) {
				this.saving = true

				const data = {
					name: this.form.name,
					lastname: this.form.lastname,
					phone: this.form.phone,
					email: this.form.email,
					password: this.form.password,
					phone: this.form.phone,
					document: this.form.document,
					business: this.form.business,
					department: this.form.department,
					avatar: this.form.avatar ? this.form.avatar.id : null,
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!, $data: SellerInput!) {
								sellerUpdate(id: $id, data: $data) {
									id
									name
									lastname
									email
									business
									avatar {
										id
										type
										urlThumb
									}
								}
							}
						`,
						variables: {
							id: this.form.id,
							data,
						},
					})
					.then(({ data }) => {
						this.saving = false
						this.$toast.success('Perfil actualizado correctamente')
						this.updateLoggedUser(data.sellerUpdate)
						this.$router.push('/')
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.saving = false
					})
			}
		},
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
	color: #fff;
}
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}
</style>
